import React from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import Detailistings from "../../DetailListings";
import { updateRequest } from "../../../../Redux/Slices/requests.slice";
import TrikeIcon from "../../../../Common/Svgs/TrikeIcon";
import TickIcon from "../../../../Common/Svgs/TickIcon";
import BatteryIcon from "../../../../Common/Svgs/BatteryIcon";
import SelectTrike from "./SelectTrike";
import SelectBatteries from "./SelectBatteries";
import { RENTAL_STATUS } from "../../../Rentals/constant";
import getRentalDate from "../../../../Utils/getRentalDate";
import { formatPhoneNumber } from "../../../../Utils/phoneNumberHelper";

const RenderBody = () => {
  const dispatch = useDispatch();

  const { currentRental } = useSelector((state) => state.rentals);
  const { transportDetailStep } = useSelector((state) => state.requests);

  const getBody = () => {
    if (+currentRental.status === RENTAL_STATUS.REJECTED) {
      return (
        <div className="pt-6 pb-12">
          <div className="py-4 px-6 bg-alert-10 rounded-xl">
            <div className="max-w-max bg-background-white py-1 px-2 border border-alert-red rounded-md">
              <p className="font-poppins font-medium text-xs leading-[18px] text-alert-red">
                Rejected
              </p>
            </div>

            <div className="mt-4 flex">
              <Detailistings
                title="Rejected By"
                value={`${currentRental?.updatedFirstName} ${currentRental?.updatedLastName}`}
              />

              <Detailistings
                title="Date & Time"
                value={dayjs(currentRental?.updatedAt).format(
                  "MMM DD, YYYY, hh:mm A",
                )}
              />
            </div>

            <p className="mt-4 font-poppins font-normal text-xs leading-[18px] text-dark-gray">
              Reason
            </p>

            <div className="mt-1 p-2 bg-background-white rounded-md font-poppins font-medium text-sm text-black first-letter:capitalize">
              {currentRental?.metaData?.reasonText}
            </div>
          </div>

          <div className="w-full h-6" />
        </div>
      );
    }

    if (
      +currentRental.status === RENTAL_STATUS.APPROVED ||
      +currentRental.status === RENTAL_STATUS.ONGOING ||
      +currentRental.status === RENTAL_STATUS.COMPLETED
    ) {
      return (
        <div className="pt-6 pb-12">
          <div className="py-4 px-6 bg-green-10 rounded-xl">
            {+currentRental.status === RENTAL_STATUS.APPROVED && (
              <div className="max-w-max bg-background-white py-1 px-2 border border-green rounded-md">
                <p className="font-poppins font-medium text-xs leading-[18px] text-green">
                  Accepted
                </p>
              </div>
            )}

            <p className="mt-3 font-poppins font-medium text-sm text-black">
              {currentRental?.batteries?.length
                ? "Vehicle & Batteries are assigned for this request"
                : "Vehicle assigned for this request"}
            </p>

            <div className="mt-3 p-4 bg-white rounded-md flex items-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-10">
                <TrikeIcon size={16} className="text-green" />
              </div>

              <p className="ml-2 flex-1 font-poppins font-medium text-base text-black">
                {currentRental?.trikeRegistrationNo}
              </p>

              <div className="bg-green-10 flex items-center py-1 px-2 rounded-md">
                <TickIcon size={16} className="text-green" />
                <p className="font-poppins font-medium text-xs leading-[18px] text-green">
                  Assigned
                </p>
              </div>
            </div>

            {currentRental?.batteries?.length ? (
              <div className="mt-3 p-4 bg-white rounded-md flex items-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-yellow-10">
                  <BatteryIcon
                    size={16}
                    className="stroke-yellow-dark fill-none"
                  />
                </div>

                <p className="ml-2 flex-1 font-poppins font-medium text-base text-black">
                  {currentRental?.batteries?.length} Batteries
                </p>

                <div className="bg-green-10 flex items-center py-1 px-2 rounded-md">
                  <TickIcon size={16} className="text-green" />
                  <p className="font-poppins font-medium text-xs leading-[18px] text-green">
                    Assigned
                  </p>
                </div>
              </div>
            ) : null}

            <div className="mt-3 flex">
              <Detailistings
                title="Accepted By"
                value={`${currentRental?.updatedFirstName} ${currentRental?.updatedLastName}`}
              />

              <Detailistings
                title="Date & Time"
                value={dayjs(currentRental?.updatedAt).format(
                  "MMM DD, YYYY, hh:mm A",
                )}
              />
            </div>
          </div>

          <div className="w-full h-6" />
        </div>
      );
    }

    if (+currentRental.status === RENTAL_STATUS.ASSIGN_TRIKE) {
      return (
        <div className="pt-6 pb-12">
          <div className="py-4 px-6 bg-green-10 rounded-xl">
            <div className="max-w-max bg-background-white py-1 px-2 border border-green rounded-md">
              <p className="font-poppins font-medium text-xs leading-[18px] text-green">
                Accepted
              </p>
            </div>

            <div className="mt-4 pb-3 flex border-b border-[#AABDBD]">
              <Detailistings
                title="Accepted By"
                value={`${currentRental?.updatedFirstName} ${currentRental?.updatedLastName}`}
              />

              <Detailistings
                title="Date & Time"
                value={dayjs(currentRental?.updatedAt).format(
                  "MMM DD, YYYY, hh:mm A",
                )}
              />
            </div>

            <div className="mt-3 pb-1">
              <p className="font-poppins font-medium text-sm text-black">
                Assign a vehicle and batteries to accept this request
              </p>

              <button
                type="button"
                className="mt-3 px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
                onClick={() =>
                  dispatch(
                    updateRequest({
                      key: "transportDetailStep",
                      value: 2,
                    }),
                  )
                }
              >
                <div className="flex item-center gap-x-2">
                  <img src="/assets/icons/add.svg" alt="" />
                  <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                    Assign Vehicle & Batteries
                  </p>
                </div>
              </button>
            </div>
          </div>

          <div className="w-full h-6" />
        </div>
      );
    }

    if (+currentRental.status === RENTAL_STATUS.PENDING) {
      return (
        <div className="mt-3 pt-3">
          <p className="font-poppins font-medium text-sm text-black">
            Accept this request and assign vehicle and batteries.
          </p>
        </div>
      );
    }

    return <div />;
  };

  if (
    +currentRental.status === RENTAL_STATUS.ASSIGN_TRIKE &&
    transportDetailStep === 2
  ) {
    return <SelectTrike />;
  }

  if (
    +currentRental.status === RENTAL_STATUS.ASSIGN_TRIKE &&
    transportDetailStep === 3
  ) {
    return <SelectBatteries />;
  }

  return (
    <div className="w-full h-full bg-background-white overflow-y-scroll">
      <div className="px-6 pb-6">
        <div
          className="rounded-xl border py-4 px-6"
          style={{
            background: "#FEFAED",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="py-1 px-2 h-[26px] max-w-max rounded-md"
            style={{ background: "#EAB726" }}
          >
            <p className="font-poppins font-medium text-xs leading-[18px] text-background-white">
              Rentals
            </p>
          </div>

          <div className="mt-4 flex items-start gap-x-4">
            <Detailistings
              title="Contact No."
              value={formatPhoneNumber(currentRental?.contactNo)}
            />

            <Detailistings
              capitalize={false}
              title="Pickup Time"
              value={`${getRentalDate(currentRental?.pickupDate)} at ${
                currentRental?.pickupTime
              }`}
            />
          </div>

          <div className="mt-4 flex items-start gap-x-4">
            <Detailistings
              title="Estimated Run"
              value={currentRental?.expectedRun}
            />

            {/* <Detailistings
              capitalize={false}
              title="Dropoff Time"
              value={`${getRentalDate(currentRental?.dropoffDate)} at ${
                currentRental?.dropoffTime
              }`}
            /> */}
          </div>
        </div>

        {/* pick up location */}
        <div className="mt-3 py-3 px-6 border border-light-grey rounded-md">
          <div
            className="max-w-max py-1 px-2 rounded-md"
            style={{ backgroundColor: "#085054" }}
          >
            <p className="font-aileron font-semibold text-10 leading-3 text-background-white">
              Pick-up From
            </p>
          </div>

          <p className="mt-3 font-poppins font-medium text-base text-black capitalize">
            {currentRental?.hubName}
          </p>
        </div>

        {getBody()}
      </div>
    </div>
  );
};

export default RenderBody;
